




































import { Component, Prop, Vue } from 'vue-property-decorator';
import CollectionStore, {
  CollectionStoreInterface,
} from '@/resource/collection/collection.store';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';

@Component({
  components: { Form },
})
export default class PaperCreateForm extends Vue {
  @Prop({ default: false })
  isLoggedIn: boolean;

  paperStore: CollectionStoreInterface = CollectionStore;
  userStore: UserStoreInterface = UserStore;
  isForgotPassword = false;
  isShowTutorialAfterCreate = false;

  inputs: InputData[] = [
    {
      name: 'name',
      value: '',
      placeholder: 'Nama Latihan',
      type: 'text',
      isRequired: true,
      maxLength: 80,
    },
    {
      name: 'subjectUuid',
      value: {
        selectedSubject: null,
        selectedForm: null,
        selectedChapter: null,
        selectedChapters: [],
      },
      type: 'dropdown-subject',
      isRequired: true,
      isHideForm: false,
      isHideChapter: false,
      isSingleChapter: true,
    },
  ];

  created() {
    if (!this.isLoggedIn) {
      this.inputs.push(
        ...[
          {
            name: 'static-text-1',
            value: 'Daftar Akaun atau Daftar Masuk',
            type: 'static-text',
          },
          {
            name: 'email',
            value: '',
            placeholder: 'Emel anda',
            type: 'text',
            isRequired: true,
            isEmail: true,
          },
          {
            name: 'phoneNumber',
            value: '',
            placeholder: 'Nombor telefon e.g. 0123754239',
            type: 'text',
            isRequired: true,
          },
          {
            name: 'role',
            value: '',
            placeholder: 'Pilih kategori anda ',
            type: 'dropdown',
            isRequired: true,
            dropdownOptions: [
              {
                value: 'teacher',
                text: 'Guru',
                isSelected: false,
              },
              {
                value: 'student',
                text: 'Murid',
                isSelected: false,
              },
              {
                value: 'parent',
                text: 'Ibu Bapa',
                isSelected: false,
              },
            ],
          },
          {
            name: 'password',
            value: '',
            placeholder: 'Kata laluan',
            type: 'password',
            isRequired: true,
            hasMinimum: 6,
          },
        ],
      );
    }
  }

  async onCreatePaperSubmit(bodyRequest: any): Promise<OnSubmitReturn | null> {
    const chapterId = bodyRequest['subjectUuid'].selectedChapter as number;
    bodyRequest['subjectUuid'] = bodyRequest['subjectUuid'].selectedSubject;

    if (!this.isLoggedIn) {
      const hasErrorRegister = await this.registerUser(bodyRequest);
      if (hasErrorRegister) {
        return hasErrorRegister;
      }
    }

    this.$sendMpEvent({
      event: this.$mp_value.PaperCreate,
      properties: {
        isAutoGenerate: true,
      },
    });

    await this.paperStore.createCollection(bodyRequest);

    if (this.paperStore.error) {
      return { error: this.paperStore.error };
    }

    if (this.paperStore.collection) {
      await this.paperStore.autoAddQuestions({
        collectionUuid: this.paperStore.collection.uuid,
        chapterId,
      });

      if (this.paperStore.error) {
        this.$toasted.global.mainToast({
          message:
            'Based on your prefences, there are no questions available yet. Contact us as at hello@mysoalan to request more questions',
        });
      }

      this.redirectToPaperPage();
    }

    return null;
  }

  async onCreateEmptyPaper(bodyRequest: any): Promise<OnSubmitReturn | null> {
    bodyRequest['subjectUuid'] = bodyRequest['subjectUuid'].selectedSubject;

    if (!this.isLoggedIn) {
      const hasErrorRegister = await this.registerUser(bodyRequest);
      if (hasErrorRegister) {
        return hasErrorRegister;
      }
    }

    this.$sendMpEvent({
      event: this.$mp_value.PaperCreate,
      properties: {
        isAutoGenerate: false,
      },
    });

    await this.paperStore.createCollection(bodyRequest);

    if (this.paperStore.error) {
      return { error: this.paperStore.error };
    }

    if (this.paperStore.collection) {
      this.redirectToPaperPage();
    }

    return null;
  }

  async registerUser(bodyRequest: any) {
    this.isShowTutorialAfterCreate = true;

    await this.userStore.signin(bodyRequest);

    if (this.userStore.error) {
      const firstName = bodyRequest.email.split('@')[0];
      await this.userStore.signup({
        firstName,
        lastName: '',
        ...bodyRequest,
      });

      if (
        this.userStore.error &&
        this.userStore.error.code === 'email_already_in_used'
      ) {
        this.userStore.error.message = 'Email and password not match';
        this.isForgotPassword = true;

        this.$sendMpEvent({
          event: this.$mp_value.ErrorSignup,
          properties: {
            error: this.userStore.error.message,
            email: bodyRequest ? bodyRequest.email : '',
          },
        });

        return { error: this.userStore.error };
      } else if (
        this.userStore.error &&
        this.userStore.error.code === 'phone_number_already_in_used'
      ) {
        this.userStore.error.message = 'Nombor telefon sudah digunakan';

        this.$sendMpEvent({
          event: this.$mp_value.ErrorSignup,
          properties: {
            error: this.userStore.error.message,
            phone: bodyRequest ? bodyRequest.phoneNumber : '',
          },
        });

        return { error: this.userStore.error };
      } else {
        this.$sendMpEvent({
          event: this.$mp_value.Signup,
          properties: {
            email: bodyRequest.email,
            phoneNumber: bodyRequest.phoneNumber,
          },
        });
        await this.userStore.signin(bodyRequest);
      }
    } else {
      this.$sendMpEvent({ event: this.$mp_value.SignIn });
    }

    this.isForgotPassword = false;
    return null;
  }

  redirectToPaperPage() {
    const paperUuid =
      (this.paperStore.collection && this.paperStore.collection.uuid) || '';

    let showTutorial = '';

    if (this.isShowTutorialAfterCreate) {
      showTutorial = '?tutorial=true';
    }

    this.$router.push(`/papers/` + paperUuid + showTutorial);
  }

  openVideoTutorialModal() {
    this.$emit('openVideoTutorialModal');
  }
}
